import React from "react";

const SingleChoice = ({ question, options, value, onChange }) => {
  return (
    <div className="single-choice-question">
      <h4 className="question-text mb-4">{question}</h4>
      <div className="options-list">
        {options.map((option, index) => (
          <div key={index} className="form-check mb-3 p-3 border rounded">
            <input
              className="form-check-input"
              type="radio"
              name="single-choice"
              id={`option-${index}`}
              value={option}
              checked={value === option}
              onChange={(e) => onChange(e.target.value)}
            />
            <label
              className="form-check-label w-100"
              htmlFor={`option-${index}`}
              style={{ cursor: "pointer", paddingLeft: "10px" }}
            >
              {option}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleChoice;
